export default "/images/7165dcd402e0004fa367ca3cbd45bac8.avif";